/**
 * Maps completed Digio KYC steps to Firebase events.
 */

import {KYC_FIREBASE_EVENTS, getKycJourneyTypeEventValue} from 'constants/kycFirebaseEvents';
import kycScreenMapping from 'types/KycScreenMapping';

import {logKycFirebaseEvent} from './logFirebaseEvents';

export const logDigioStepCompletedEvent = (flow, stage, kycData = {}) => {
  const normalizedStage = String(stage || '').toUpperCase();

  console.log(flow, stage, kycData);

  switch (normalizedStage) {
    case kycScreenMapping.SELFIE:
      logKycFirebaseEvent(flow, KYC_FIREBASE_EVENTS.IPV_COMPLETED);
      break;

    case kycScreenMapping.SPECIMEN_SIGN:
      logKycFirebaseEvent(flow, KYC_FIREBASE_EVENTS.SIGNATURE_COMPLETED);
      break;

    case kycScreenMapping.E_SIGN:
      logKycFirebaseEvent(flow, KYC_FIREBASE_EVENTS.ESIGN_COMPLETED, {
        kycJourneyType: getKycJourneyTypeEventValue(flow, kycData),
      });
      break;

    case kycScreenMapping.DIGILOCKER:
      logKycFirebaseEvent(flow, KYC_FIREBASE_EVENTS.DIGILOCKER_COMPLETED, {
        kycJourneyType: getKycJourneyTypeEventValue(flow, kycData),
      });
      break;

    default:
      break;
  }
};

export const logEsignStartedEvent = (flow, kycData = {}) => {
  logKycFirebaseEvent(flow, KYC_FIREBASE_EVENTS.ESIGN_STARTED, {
    kycJourneyType: getKycJourneyTypeEventValue(flow, kycData),
  });
};
